export const VENDOR_ITEM_QUERY_KEY = 'vendor-item';

export interface VendorItemQuery {
  identifier: string;
}

export function getVendorItemQueryKey(query: VendorItemQuery) {
  return [VENDOR_ITEM_QUERY_KEY, query] as const;
}
